<template>
<main class="projects">
  <div class="switcher">
    <router-link :to="{ name: 'projects', hash: '' }" :class="{ active: $route.hash == '' }">
      <txt phrase="Images" />
    </router-link>
    <router-link :to="{ name: 'projects', hash: '#list' }" :class="{ active: $route.hash == '#list' }">
      <txt phrase="List" />
    </router-link>
  </div>
  <section class="project-images" v-if="$route.hash == '#images' || $route.hash == ''">
    <masonry :cols="{ default: 3, 768: 2 }" :gutter="32">
        <project-item v-for="project in projects" :key="project.uid" :project="project" />
    </masonry>
  </section>
  <table v-else>
    <thead>
      <tr>
        <td @click="sort('number')">
          #
          <div class="sorter">
            <span v-show="currentSort === 'number' && currentSortDir === 'asc'"> &uarr;</span>
            <span v-show="currentSort === 'number' && currentSortDir === 'desc'"> &darr;</span>
          </div>
        </td>
        <td @click="sort('title')">
          Title
          <div class="sorter">
            <span v-show="currentSort === 'title' && currentSortDir === 'asc'"> &uarr;</span>
            <span v-show="currentSort === 'title' && currentSortDir === 'desc'"> &darr;</span>
          </div>
        </td>
        <td @click="sort('year')">
          Year
          <div class="sorter">
            <span v-show="currentSort === 'year' && currentSortDir === 'asc'"> &uarr;</span>
            <span v-show="currentSort === 'year' && currentSortDir === 'desc'"> &darr;</span>
          </div>
        </td>
        <td @click="sort('location')">
          Location
          <div class="sorter">
            <span v-show="currentSort === 'location' && currentSortDir === 'asc'"> &uarr;</span>
            <span v-show="currentSort === 'location' && currentSortDir === 'desc'"> &darr;</span>
          </div>
        </td>
        <td @click="sort('type')">
          Type
          <div class="sorter">
            <span v-show="currentSort === 'type' && currentSortDir === 'asc'"> &uarr;</span>
            <span v-show="currentSort === 'type' && currentSortDir === 'desc'"> &darr;</span>
          </div>
        </td>
        <td @click="sort('surface')">
          Surface
          <div class="sorter">
            <span v-show="currentSort === 'surface' && currentSortDir === 'asc'"> &uarr;</span>
            <span v-show="currentSort === 'surface' && currentSortDir === 'desc'"> &darr;</span>
          </div>
        </td>
        <td @click="sort('projectstatus')">
          Status
          <div class="sorter">
            <span v-show="currentSort === 'projectstatus' && currentSortDir === 'asc'"> &uarr;</span>
            <span v-show="currentSort === 'projectstatus' && currentSortDir === 'desc'"> &darr;</span>
          </div>
        </td>
      </tr>
    </thead>
    <tbody>
      <router-link v-for="project in sortedProjects" :key="project.uid" :to="{ name: 'project', params: { id: project.uid } }">
        <td class="tnum">
          {{ project.number }}
        </td>
        <td>
          <txt :phrase="project.title" />
        </td>
        <td class="tnum" v-if="project.year">
          <txt :phrase="project.year" />
        </td>
        <td v-else>–</td>
        <td v-if="project.location">
          <txt :phrase="project.location" />
        </td>
        <td v-else>–</td>
        <td v-if="project.type">
          <txt :phrase="project.type" />
        </td>
        <td v-else>–</td>
        <td class="tnum" v-if="project.surface">
          <txt :phrase="project.surface" /> m2</td>
        <td v-else>–</td>
        <td v-if="project.projectstatus">
          <txt :phrase="project.projectstatus" />
        </td>
        <td v-else>–</td>
      </router-link>
    </tbody>
  </table>
</main>
</template>

<script>
const Txt = () => import( /* webpackChunkName: "TableText" */ '@/components/TableText.vue')
const ProjectItem = () => import( /* webpackChunkName: "ProjectItem" */ '@/components/ProjectItem.vue')

import {
  mapState
} from 'vuex'
export default {
  name: 'projects',
  metaInfo: {
    title: '– Projects',
  },
  components: {
    Txt,
    ProjectItem,
  },
  data() {
    return {
      currentSort: 'number',
      currentSortDir: 'desc'
    }
  },
  computed: {
    ...mapState(['projects']),
    sortedProjects() {
      let projects = this.projects
      let sorted = projects.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      })
      return sorted
    }
  },
  methods: {
    sort: function(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    }
  }
}
</script>

<style lang="scss" scoped>
.switcher {
    position: absolute;
    top: var(--lh);
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    a:last-of-type {
        margin-left: calc(0.5 * var(--lh));
    }
    @media only screen and (max-width:768px) {
        position: relative;
        left: auto;
        top: auto;
        transform: none;
        padding-bottom: var(--lh);
    }
}
.sorter {
    display: inline-block;
    width: 6px;
}
table {
    font-family: "SimilarMed", Helvetica, Arial, sans-serif;
    font-size: calc(0.6 * var(--fs));
    line-height: 1.2;
    width: 100%;
    a,
    tr {
        display: table-row;
        border-bottom: 1px solid var(--hover);
    }
    thead {
        td {
            user-select: none;
            cursor: pointer;
        }
    }
    td {
        padding: calc(0.5 * var(--lh)) calc(0.5 * var(--lh)) calc(0.5 * var(--lh)) 0;
        &:last-of-type {
            padding-right: 0;
        }
    }
    @media only screen and (max-width:1024px) {
        td {
            display: none;
            &:first-of-type,
            &:nth-of-type(2),
            &:nth-of-type(3),
            &:nth-of-type(5) {
                display: table-cell;
            }
        }
    }
}
</style>
